import { KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

/**
 * How every catalog list starts a drag: the pointer after a few pixels, so a
 * click on the grip stays a click, and the keyboard (Space to lift, arrows to
 * move, Space to drop) — which is what keeps ordering reachable without a mouse
 * once the arrows are gone on desktop.
 */
export function useCatalogDragSensors(): ReturnType<typeof useSensors> {
  return useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
}
